import { schema } from 'normalizr'
import { supportParameterSchema } from 'schemas/supportParameter'

export const compatibilityModulesSchema = new schema.Entity(
  'compatibilityModules',
  {},
  {
    idAttribute: 'uri',
  }
)
// TODO: remove after verifying
// export const compatibilityModulesResponseSchema = new schema.Object({
//   compatibilityModules: [compatibilityModulesSchema],
// })
export const compatibilityModulesResponseSchema = [compatibilityModulesSchema]

export const referenceParameterSchema = new schema.Entity(
  'referenceParameters',
  {
    supportParameters: [supportParameterSchema],
    compatibilityModules: [compatibilityModulesSchema],
  },
  {
    idAttribute: 'uri',
  }
)

export const referenceParameterResponseSchema = new schema.Object({
  referenceParameter: referenceParameterSchema,
})
